import { devChunkLoadErrors } from './dev-chunk-load-errors';
import { loginFailures } from './login-failures';

const filters = [devChunkLoadErrors, loginFailures];

// This could be changed to return a modified event but for now
// the filters are just boolean to determine whether to send the event.
// If any filter returns false, the event will not be sent.
export function filterEvent(event, hint) {
  try {
    return filters.every((f) => f(event, hint)) ? event : null;
  } catch (e) {
    // just to be safe: if any of the filters throw an error send the event
    console.error(e);
    return event;
  }
}
